import { asArray, BadImplementationException, dbObjectToId, deepClone } from '@nu-art/ts-common';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { Page_BaseManagerUI } from './Page_BaseManagerUI.js';
export class Page_BaseManagerUI_SingleType_Proto extends Page_BaseManagerUI {
    constructor(p) {
        super(p);
        const method = p.searchItems[0].module.defaultDispatcher.method;
        // @ts-ignore
        this[method] = this.__onItemUpdated;
        // @ts-ignore
        this[method].bind(this);
        this.getInitialObject.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.state?.tag !== nextState.selectedItem?.tag)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    __onItemUpdated(...params) {
        const selectedResult = this.state.selectedResult;
        if (selectedResult?.type !== this.getModule().dbDef.dbKey)
            return;
        const updatedItems = asArray(params[1]);
        switch (params[0]) {
            case 'update':
            case 'upsert-all':
                if (updatedItems.map(dbObjectToId).includes(selectedResult.id)) {
                    const updateItem = deepClone(updatedItems).find(item => item._id === selectedResult.id);
                    this.state.selectedItem?.updateItem(updateItem);
                }
                break;
            case 'delete':
            case 'delete-multi':
                if (updatedItems.map(dbObjectToId).includes(selectedResult.id))
                    this.clearSelectedResult();
                break;
        }
    }
    getModule() {
        return this.props.searchItems[0].module;
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        const selectedItem = this.getModule().cache.unique(state.selectedResult?.id);
        if (state.selectedResult?.id && !selectedItem)
            throw new BadImplementationException(`Received id ${state.selectedResult?.id} for ${this.props.searchItems[0].type}, .`);
        if (state.selectedItem && state.selectedItem.item._id === selectedItem?._id)
            return state;
        if (!state.selectedResult) {
            delete state.selectedItem;
            return state;
        }
        state.selectedItem = this.getEditableItem(selectedItem);
        state.tag = state.selectedItem.tag;
        return state;
    }
    clearSelectedResult() {
        super.clearSelectedResult();
        this.setState({ selectedItem: undefined, selectedResult: undefined });
    }
    getEditableItem(item = this.getInitialObject()) {
        const newEditable = new EditableDBItemV3(item, this.getModule())
            .setOnChanged(async (editable) => {
            if (editable.get('_id'))
                editable.setAutoSave(this.props.autoSave ?? true);
            if (this.state)
                this.setState({ selectedItem: editable });
        });
        if (item._id)
            newEditable.validate();
        newEditable.setAutoSave(this.props.autoSave ?? !!item._id);
        return newEditable;
    }
}
//# sourceMappingURL=Page_BaseManagerUI_SingleType_Proto.js.map